import {Component, EventEmitter, Input, Output, inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { AppointmentRecord } from '../../models/salesforce.models';
import { AsyncPipe, CommonModule, Time } from '@angular/common';
import { CustomDatePipe } from '../../shared/pipes/custom-date.pipe';
import { TranslocoModule } from '@ngneat/transloco';
import { CoachingSession } from '../../models/coaching-session.models';
import { CoachingSessionService } from '../../services/coaching-session.service';
import { AppState } from '../../store/app.state';
import { Store } from '@ngrx/store';
import { selectUserData } from '../../store/user/user.selectors';
import { ModalService } from '../../services/modal.service';
import { RescheduleModalComponent } from '../reschedule-modal/reschedule-modal.component';
import dayjs from 'dayjs';
import {Chart, ChartItem, registerables} from "chart.js";
import {ChartConfiguration} from "chart.js/dist/types";
import {SurveyService} from "../../services/survey.service";
import {Survey} from "../../models/survey.models";
import {LogService} from "../../services/log.service";

@Component({
    selector: 'life-wheel-chart',
    standalone: true,
    imports: [CommonModule, TranslocoModule],
    templateUrl: './life-wheel-chart.component.html',
    styleUrl: './life-wheel-chart.component.css',
})
export class LifeWheelChartComponent implements AfterViewInit {
    @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;
    @ViewChild('chartContainer') chartContainer!: ElementRef<HTMLDivElement>;

    @Input() isHCA = false;

    #surveyService = inject(SurveyService);
    #logService = inject(LogService);

    data: Survey | null = null;
    chartInstance: Chart<'polarArea', any, any> | null = null;

    constructor() {
        Chart.register(...registerables);
    }

    ngAfterViewInit() {
        (this.isHCA ? this.#surveyService.getHCALifeWheelSurveyLastResponse() : this.#surveyService.getLifeWheelSurveyLastResponse()).subscribe({
            next: (surveyData) => {
                this.#logService.log(this.isHCA ? 'getHCALifeWheelSurveyLastResponse' : 'getLifeWheelSurveyLastResponse', surveyData);

                if (!surveyData) {
                    this.#logService.log('No survey data found');
                    return;
                }

                this.data = surveyData;

                const chartData = {
                    labels: this.data.surveyVersion.surveyResponses[0]?.surveyQuestionResponses.map(response => {
                        return response.graphLabel ?? response.id;
                    }),
                    datasets: [{
                        data: this.data.surveyVersion.surveyResponses[0]?.surveyQuestionResponses.map(response => {
                            return response.numericValue;
                        }),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.5)',
                            'rgba(54, 162, 235, 0.5)',
                            'rgba(255, 206, 86, 0.5)',
                            'rgba(75, 192, 192, 0.5)',
                            'rgba(153, 102, 255, 0.5)',
                            'rgba(255, 159, 64, 0.5)',
                            'rgba(231, 76, 60, 0.5)',
                            'rgba(26, 188, 156, 0.5)',
                            'rgba(52, 152, 219, 0.5)',
                            'rgba(155, 89, 182, 0.5)'
                        ]
                    }]
                };

                const config: ChartConfiguration<'polarArea', any, any> = {
                    type: 'polarArea',
                    data: chartData,
                    options: {
                        responsive: true,
                        scales: {
                            r: {
                                min: 0,
                                max: 10,
                                ticks: {
                                    z: 1,
                                    backdropColor: 'rgba(255, 255, 255, 0)'
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'top',
                            },
                            title: {
                                display: true,
                                text: 'Ruota della Vita'
                            }
                        }
                    },
                };

                const ctx = this.chartCanvas.nativeElement.getContext('2d');
                const myChart = ctx as ChartItem;

                this.chartInstance = new Chart(myChart, config);
            },
            error: (error) => {
                this.#logService.error('Error getting life wheel survey data', error);
            }
        });
    }
}
